import React from 'react';
import styled, { css } from 'styled-components';

import { createGRN } from 'logic/permissions/GRN';
import useShowRouteFromGRN from 'routing/hooks/useShowRouteFromGRN';
import { RestrictedAccessTooltip } from 'components/common';
import { Link } from 'components/common/router';
import IconButton from 'components/common/IconButton';
import useHasEntityPermissionByGRN from 'hooks/useHasEntityPermissionByGRN';
import type { OverrideItemComponentProps } from 'components/common/PaginatedItemOverview';

const Container = styled.span(
  ({ theme }) => css`
    display: flex;
    padding: 10px;
    background-color: ${theme.colors.table.row.background};

    &:nth-of-type(even) {
      background-color: ${theme.colors.table.row.backgroundStriped};
    }
  `,
);

const Header = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin-right: 5px;
`;

const Description = styled.span`
  flex: 2;
`;

const StyledDeleteButton = styled(IconButton)`
  flex: 0;
`;

const UserItemComponent = ({ onDeleteItem, item }: OverrideItemComponentProps) => {
  const entityGRN = createGRN('user', item.id);

  const entityRoute = useShowRouteFromGRN(entityGRN);

  const deleteButton =
    typeof onDeleteItem === 'function' ? (
      <StyledDeleteButton onClick={() => onDeleteItem(item)} name="close" title={`Remove ${item.name}`} />
    ) : null;

  const hasEditPermissions = useHasEntityPermissionByGRN(entityGRN, 'edit');

  return (
    <Container>
      <Header>
        {hasEditPermissions ? (
          <Link to={entityRoute}>{item.name}</Link>
        ) : (
          <>
            {item.name}
            <RestrictedAccessTooltip entityName="user" capabilityName="view" />
          </>
        )}
      </Header>
      <Description>{item.description}</Description>
      {deleteButton}
    </Container>
  );
};

export default UserItemComponent;
